export const COLORS = [
  '#EF3EB5',
  '#4B256D',
  '#40E0D0',
  '#000000',
  '#FF0000',
  '#00FF00',
  '#FFD700',
  '#695D54',
];
